import PanoViewerSmallViewPort from "./PanoViewerSmallViewPort";

export default PanoViewerSmallViewPort;
